import * as Yup from "yup";

export const getSelectContactTabSchema = () =>
  Yup.object().shape({
    walletName: Yup.object().required("Wallet is required"),
    payoutCurrency: Yup.object().required("Settlement Currency is required"),
    paymentCode: Yup.object().required("Payment Method is required"),
    contactId: Yup.object().required("Contact is required"),
  });

export const getValidationSchema = () => [getSelectContactTabSchema()];
